import React, { useCallback, useContext, useEffect } from "react";
import { EventOnScroll } from "../CommonForm/CommonFormInterface";
import getData from "@/commonJS/getData";
import { CommonFormContext } from "../MainComponent/MainComponent";
import dynamic from "next/dynamic";
const CommonForm = dynamic(()=> import("../CommonForm/CommonForm"))

const ScrollableContainerWithEvent = React.memo(({
  field,
  globalState,
  fullGlobalState,
  path
}: {
  field: EventOnScroll;
  globalState: any;
  fullGlobalState: any;
  path: string[]
}) => {
  const context = useContext(CommonFormContext);
  const data = field?.dataFrom
    ? getData(
        field?.dataFrom,
        field?.dataFrom?.source === "GLOBAL"
          ? fullGlobalState
          : field?.dataFrom?.source === "REDUX"
          ? globalState
          : globalState
      )
    : field?.data
    ? field?.data
    : [];

  const isElementInViewport = (element: any, parent: any) => {
    const parentRect = parent.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    return (
      elementRect.top < parentRect.bottom &&
      elementRect.bottom > parentRect.top
    );
  };

  useEffect(() => {
    const watchField = document.getElementById(`scroll-container-${field?.id}`);
    let actionTriggered = false;

    const handleScroll = (event: any) => {
      if (actionTriggered || !watchField) return;
      const children = watchField.children;
      if (children.length === 0) return;

      const lastChild = children[children.length - 1];

      const isVisible = isElementInViewport(lastChild, watchField);

      if (isVisible) {
        actionTriggered = true;
        context.handleClick && field.properties?.onVisibleElement?.actions
          ? context.handleClick(
              event,
              field.properties?.onVisibleElement,
              globalState
            )
          : () => {};
      }
    };

    const observer = new MutationObserver(() => {
      actionTriggered = false;
    });

    
    if (watchField) {
      observer.observe(watchField, { childList: true, subtree: true });
      watchField.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (watchField) {
        watchField.removeEventListener("scroll", handleScroll);
      }
    };
  }, [globalState]);
  const scrollPath = useCallback((index:number)=>[...path??[], `scrollable-container-sr-item-${index}`],[path]);
  return (
    <div
      id={`scroll-container-${field?.id}`}
      className={`${field?.className ?? ""}`}
      style={{ ...field?.style }}
    >
      {(data ?? []).length > 0 &&
        data.map((item: any, index: number) => (
          <CommonForm
            key={scrollPath(index).join("-")}
            path={scrollPath(index)}
            formJSON={[field.structure]}
            globalState={item}
            fullGlobalState={fullGlobalState ?? globalState}
          />
        ))}
    </div>
  );
});

export default ScrollableContainerWithEvent;
